// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2de1e026","678":"25c962d1","705":"899a84c2","787":"bf32509e","819":"6d862efc","835":"1dd0d682","845":"5cf34611","921":"2f663819"}[chunkId] + ".chunk.js";
};